import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    * {
        padding: 0;
        margin: 0;
        outline: none;
        box-sizing: border-box;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;;
        
        a {
            text-decoration: none;
        }

        ul {
            list-style: none;
        }

        body {
            background-color: ${({ theme }) => theme.colors.background};
            // padding-top: 2rem;
        }
    };
`;
